import { ChannelRotator } from "@juristai/ui";

export default ChannelRotator;

